import { render, staticRenderFns } from "./AS_HomeBottomFixedNav.vue?vue&type=template&id=57eb2b27&scoped=true&"
import script from "./AS_HomeBottomFixedNav.vue?vue&type=script&lang=js&"
export * from "./AS_HomeBottomFixedNav.vue?vue&type=script&lang=js&"
import style0 from "./AS_HomeBottomFixedNav.vue?vue&type=style&index=0&id=57eb2b27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb2b27",
  null
  
)

export default component.exports